/// <reference types="./default-insert-value-node.d.ts" />
import { freeze } from '../util/object-utils.js';
/**
 * @internal
 */
export const DefaultInsertValueNode = freeze({
    is(node) {
        return node.kind === 'DefaultInsertValueNode';
    },
    create() {
        return freeze({
            kind: 'DefaultInsertValueNode',
        });
    },
});
